import { render, staticRenderFns } from "./tyzf.vue?vue&type=template&id=4ff64d94&scoped=true&"
import script from "./tyzf.vue?vue&type=script&lang=js&"
export * from "./tyzf.vue?vue&type=script&lang=js&"
import style0 from "./tyzf.vue?vue&type=style&index=0&id=4ff64d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff64d94",
  null
  
)

export default component.exports